// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@media print {\n  .app-container,\n.layout-wrapper,\n.layout-main {\n    height: auto;\n  }\n\n  .layout-aside {\n    display: none;\n  }\n}", "",{"version":3,"sources":["print.scss"],"names":[],"mappings":"AAAA;EACE;;;IAGE,YAAA;EACF;;EAEA;IACE,aAAA;EACF;AACF","file":"print.scss","sourcesContent":["@media print {\r\n  .app-container,\r\n  .layout-wrapper,\r\n  .layout-main {\r\n    height: auto;\r\n  }\r\n\r\n  .layout-aside {\r\n    display: none;\r\n  }\r\n  \r\n}"]}]);
// Exports
module.exports = exports;
